import { okamiHttpGateway } from '@/lib/axios'
import { useMutation } from '@tanstack/react-query'

export interface LogoutInput {
  refreshToken: string | null
}

export const logoutMutationKey = ['logout'] as const

export async function makeLogout(data: LogoutInput) {
  await okamiHttpGateway.post('auth/logout', {
    refreshToken: data?.refreshToken,
  })
}

export const getMakeLogoutMutationOptions = () => ({})

export function useMakeLogout() {
  return useMutation({
    mutationKey: logoutMutationKey,
    mutationFn: makeLogout,
    meta: {
      errorMessage: 'Erro ao fazer logout',
      invalidateQueryOnSuccess: ['user-details'],
    },
  })
}
